require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./select"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./select"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./select")) : factory(root["./utils"], root["./select"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__49__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[53],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(466);


/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _SelectGroup = _interopRequireDefault(__webpack_require__(467));

exports["default"] = _SelectGroup["default"];
exports.SelectGroup = _SelectGroup["default"];

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _select = _interopRequireDefault(__webpack_require__(49));

var _SelectGroup = _interopRequireDefault(__webpack_require__(468));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var selectGroupClassName = _SelectGroup["default"].selectGroupClassName.replace(/"/g, '');

var SelectGroup = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(SelectGroup, _Component);

  function SelectGroup() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SelectGroup.prototype;

  _proto._onChange = function _onChange(v, i) {
    var _this$props = this.props,
        onChange = _this$props.onChange,
        selected = _this$props.selected;

    if (onChange) {
      var value = selected.slice(0, i);
      value[i] = v;
      onChange(value, i);
    }
  };

  _proto._createSelects = function _createSelects(selects, options, i) {
    var _this = this;

    var _this$props2 = this.props,
        lastId = _this$props2.lastId,
        className = _this$props2.className,
        selected = _this$props2.selected,
        hover = _this$props2.hover,
        active = _this$props2.active,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["lastId", "className", "selected", "hover", "active"]);
    var selectPassthroughProps = getInheritedProps(others, _select["default"]);
    options.items.forEach(function (option) {
      if (option.children && selected[i] === option.value) {
        _this._createSelects(selects, option.children, i + 1);
      }
    });

    if (options.items.length) {
      var isLast = selects.length === 0;
      selects.unshift( /*#__PURE__*/_react["default"].createElement("div", {
        className: selectGroupClassName + "__item",
        "data-tid": "ba-common-select-group__select-" + i,
        key: i
      }, /*#__PURE__*/_react["default"].createElement(_select["default"], (0, _extends2["default"])({}, selectPassthroughProps, {
        active: isLast && active,
        hover: isLast && hover,
        id: isLast ? lastId : null,
        label: options.groupLabel,
        onChange: function onChange(v) {
          return _this._onChange(v, i);
        },
        options: options.items,
        selected: selected[i] ? selected[i] : ''
      }))));
    }
  };

  _proto._createAllSelects = function _createAllSelects() {
    var options = this.props.options;
    var selects = [];

    this._createSelects(selects, options, 0);

    return selects;
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        align = _this$props3.align,
        className = _this$props3.className,
        id = _this$props3.id,
        style = _this$props3.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props3, ["align", "className", "id", "style"]);
    var classNames = (0, _utils.classnames)(selectGroupClassName, align);
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      className: classNames + " " + className,
      id: id,
      style: style
    }, sanitize(others, SelectGroup)), this._createAllSelects());
  };

  return SelectGroup;
}(_react.Component);

exports["default"] = SelectGroup;
(0, _defineProperty2["default"])(SelectGroup, "__SelectGroup__", true);
(0, _defineProperty2["default"])(SelectGroup, "propTypes", (0, _extends2["default"])({}, sanitize(_select["default"].propTypes, null, 'id'), {
  /** Passed as a prop to each select component */
  active: _propTypes["default"].bool,

  /** Sets allignment to left or right */
  align: _propTypes["default"].oneOf(['left', 'right']),

  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Not used, will be depricated soon */
  disabled: _propTypes["default"].bool,

  /** Passed as a prop to each select component */
  hover: _propTypes["default"].bool,

  /** Unique ID for each select component */
  id: _propTypes["default"].string,

  /** ID of the last Select component */
  lastId: _propTypes["default"].string,

  /** Callback function on selection change */
  onChange: _propTypes["default"].func.isRequired,

  /** Contains a hierarchy of items for all select components */
  options: _propTypes["default"].object.isRequired,

  /** Not used, will be depricated soon */
  readOnly: _propTypes["default"].bool,

  /** Sets the array of selected values */
  selected: _propTypes["default"].array.isRequired,

  /** Not used, will be depricated soon */
  size: _propTypes["default"].string,

  /** Custom CSS styling */
  style: _propTypes["default"].object
}));
(0, _defineProperty2["default"])(SelectGroup, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(469);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-selectGroup{display:inline-block;max-width:100%}.ba-common-selectGroup.is-left{text-align:left}.ba-common-selectGroup.is-right{text-align:right}.ba-common-selectGroup__item{display:block}.ba-common-selectGroup__item:not(:last-child){margin-bottom:16px}\n", ""]);

// exports
exports.locals = {
	"selectGroupClassName": "\"ba-common-selectGroup\""
};

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__49__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[465,0]]]);
});